/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { services } from '../../services';
import { API_ENDPOINTS } from '../../config/api';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await services.put(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
      navigate('/login');
    } catch (err: any) {
      setError(err?.data?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center p-4'>
      <div className='w-full max-w-md border rounded-xl p-6'>
        <h2 className='text-xl font-semibold text-center mb-2'>Reset password</h2>
        <p className='text-center text-sm text-muted-foreground mb-6'>Enter your new password</p>
        <form className='space-y-4' onSubmit={onSubmit}>
          <div>
            <label className='text-sm font-medium' htmlFor='password'>New password</label>
            <Input id='password' type='password' value={password} onChange={(e) => setPassword(e.target.value)} required placeholder='••••••••' />
          </div>
          <div>
            <label className='text-sm font-medium' htmlFor='confirm'>Confirm password</label>
            <Input id='confirm' type='password' value={confirm} onChange={(e) => setConfirm(e.target.value)} required placeholder='••••••••' />
          </div>
          {error && <div className='text-destructive text-sm bg-destructive/10 p-2 rounded-md'>{error}</div>}
          <Button type='submit' className='w-full' disabled={loading}>{loading ? 'Saving...' : 'Reset password'}</Button>
        </form>
        <p className='text-sm text-center mt-4'><Link to='/login' className='underline'>Back to sign in</Link></p>
      </div>
    </div>
  );
};

export default ResetPassword;


